import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿SAINT® requiere anestesia o medicación?",
    answer:
      "No. SAINT® se administra con el paciente despierto, sin anestesia ni sedación. No se administra medicación como parte del tratamiento de SAINT®. El equipo clínico revisa la medicación actual durante la evaluación.",
  },
];

export const esRequiresAnesthesiaOrMedication = makeEsArticle({
  slug: "does-saint-tms-require-anesthesia-or-medication",
  title: "¿SAINT® requiere anestesia o medicación?",
  description:
    "SAINT® no requiere anestesia ni sedación, y no se administra medicación como parte del tratamiento. El equipo clínico revisa la medicación actual durante la evaluación.",
  h1: "¿SAINT® requiere anestesia o medicación?",
  breadcrumbLabel: "Anestesia o medicación en SAINT®",
  shortAnswer:
    "No. SAINT® se administra con el paciente despierto, sin anestesia ni sedación. No se administra medicación como parte del tratamiento de SAINT®. El equipo clínico revisa la medicación actual y las contraindicaciones durante la evaluación psiquiátrica antes de empezar. SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos.",
  keyTakeaways: [
    "SAINT® no requiere anestesia ni sedación.",
    "No se administra medicación como parte de SAINT®.",
    "El equipo revisa la medicación actual durante la evaluación.",
    "El paciente permanece despierto.",
    "SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos.",
  ],
  sections: [
    {
      heading: "Sin anestesia ni sedación",
      paragraphs: [
        "SAINT® utiliza estimulación magnética transcraneal, no estimulación eléctrica. El paciente permanece despierto y alerta durante cada sesión. No se usa anestesia, sedación ni una sala de recuperación.",
      ],
    },
    {
      heading: "Medicación",
      paragraphs: [
        "No se administra medicación como parte del tratamiento de SAINT®. El equipo clínico revisa la medicación actual y las posibles interacciones o contraindicaciones durante la evaluación psiquiátrica antes de planificar la semana de tratamiento.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
